import SocialMedia from "./SocialMedia";
import React from "react";

export default function Grin() {  
    return <SocialMedia 
    cacheKey="grin_cache" 
    requiredParameters=
    {{'platform': 'grin',
        'token': true,
        'link_id': true,
        'contact_id': true}}/>; 
}